import { useContext, useEffect, useState } from 'react'

// context
import { AppContext } from '../../../App'

// components
import Image from '../../image/image'
import StepCardLoader from '../../step-card-loader/step-card-loader'
import StepCard from '../../step-card/step-card'
import AccidentDetails from './components/accident-details'
import ClaimAssistPredictions from './components/claim-assist-predictions'
import InjuryInsight from './components/injury-insight'
import InjuryReview from './components/injury-review'

// utils
import { callAPI } from '../../../utils/api'

// styles
import styles from './bmr-page.module.scss'

const BMRPage = (): JSX.Element => {
	const appContext = useContext(AppContext)
	const [isLoading, setLoading] = useState(true)

	let scenario = appContext?.claimNumber
		? parseInt(appContext?.claimNumber.toString().charAt(0))
		: 1
	if (scenario < 0 || isNaN(scenario)) {
		scenario = 1
	}
	if (scenario > 3) {
		scenario = 3
	}

	useEffect(() => {
		callAPI('biomechanical-mock', {
			method: 'POST',
			body: JSON.stringify({
				scenario: scenario,
				deltav: appContext?.deltaV?.deltav,
				error: appContext?.deltaV?.error,
			}),
			successCallback: (data) => {
				appContext?.setBiomechanicalReport(data)
				setLoading(false)
			},
			errorCallback: () => {
				appContext?.setBiomechanicalReport(undefined)
				setLoading(false)
			},
		})
	}, [])

	return (
		<StepCard
			stepTitle="Biomechanical Review
"
		>
			{isLoading ? (
				<StepCardLoader />
			) : (
				<div className="animate-appear">
					<div className={styles.header}>
						<div>
							<Image src={appContext?.uploadedImage?.url} />
							<AccidentDetails />
						</div>

						<div>
							<Image src={appContext?.uploadedImage?.url} />
							<InjuryInsight />
						</div>
					</div>

					<InjuryReview />

					<ClaimAssistPredictions />
				</div>
			)}
		</StepCard>
	)
}
export default BMRPage
